import { dispatch } from '../internal.js';
import * as actionTypes from './actionTypes.js';
export const toggleLeftNav = () => dispatch({ type: actionTypes.TOGGLE_LEFT_NAV_OPEN });
export const toggleRightNav = () => dispatch({ type: actionTypes.TOGGLE_RIGHT_NAV_OPEN });
//# sourceMappingURL=actions.js.map